(function(){
    angular
        .module('appback')
        .directive('ngLiberarstock', liberarStock);
        liberarStock.$inject = ['HojaService','StockService','$timeout', 'Upload'];
        function liberarStock(HojaService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=liberarstock.twig',
		          scope: {
                  lote:'=',
                  hc:"="
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        console.log("scopeh",scope.hc.hojafabricacionactiva);
                        scope.stock = {};
                        scope.cantidad_liberar = 0;
                        scope.almacen_id = scope.hc.hojafabricacionactiva.almacen_id;
                        scope.init = function(){
                            function loadStock(){
                                StockService.getStockFromHojaId(scope.hc.hojafabricacionactiva.id,function(dataStock){
                                    scope.stockInfo = dataStock;
                                    console.log("stockInfo", scope.stockInfo);
                                    switch (scope.stockInfo.code) {
                                        case -10:
                                            $timeout(loadStock, 5000);
                                            break;
                                        default:
                                            scope.stock = dataStock.stock_de_material;
                                            break;
                                    }
                                });
                            }
                            loadStock();
                        }
                        scope.init();

                        scope.puedoLiberar = function(almacen_required){
                            console.log(scope.cantidad_liberar, scope.stock.cantidad, scope.almacen_id);
                            if(almacen_required && !scope.almacen_id){
                                return false;
                            }

                            var cantidad_a_liberar = parseFloat(scope.cantidad_liberar) || 0;
                            var cantidad_en_stock = parseFloat(scope.stock.cantidad) || 0;

                            if(cantidad_a_liberar <= 0){
                                return false;
                            }
                            return cantidad_a_liberar <= cantidad_en_stock;
                        }
                        
                        scope.liberarStock = function(cantidad_liberar, almacen_id){
                            console.log('Funcion liberarStock', scope.stock.id);
                            console.log("cantidad a liberar", cantidad_liberar);
                            console.log("almacen a liberar", almacen_id);
                            StockService.liberarStockMaterial(scope.stock.id, cantidad_liberar, scope.hc.hojafabricacionactiva,almacen_id, function(data){
                                console.log("data liberarstock",data);
                                if(data.code ==1){
                                    scope.stock.cantidad -= cantidad_liberar;
                                    if(scope.stock.cantidad <= 0){
                                        scope.hc.liberacion_pendiente = false;
                                    }
                                    scope.cantidad_liberar = 0;
                                    scope.hc.existe_liberado = true;
                                    if(data.acciones){
                                        scope.hc.hojafabricacionactiva.acciones = data.acciones;
                                    }
                                }else{
                                    console.log("Error al liberar stock", data);
                                }
                                scope.init();
                            })
                        }

                        scope.liberarTodoStock = function(almacen_id){
                            console.log("liberando todo el stock al almacen", almacen_id, scope.stock.cantidad);
                            scope.liberarStock(scope.stock.cantidad, almacen_id);
                        }

                        scope.rechazarStock = function(cantidad_liberar){
                            StockService.rechazarStockMaterial(scope.stock.id, cantidad_liberar, scope.hc.hojafabricacionactiva, function(data){
                                console.log("data rechazarStockMaterial",data);
                                if(data.code ==1){
                                    scope.stock.cantidad -= cantidad_liberar;
                                    if(scope.stock.cantidad <= 0){
                                        scope.hc.liberacion_pendiente = false;
                                    }
                                    scope.cantidad_liberar = 0;
                                    if(data.acciones){
                                        scope.hc.hojafabricacionactiva.acciones = data.acciones;
                                    }
                                }else{
                                    console.log("Error al rechazar stock", data);
                                }
                                scope.init();
                            });
                        }

                        scope.rechazarTodoStock = function(){
                            console.log("rechazando todo el stock");
                            scope.rechazarStock(scope.stock.cantidad);
                        }
			        });
		        }
          }
      }
})();